import { render, staticRenderFns } from "./HealthRecords.vue?vue&type=template&id=5f595318&scoped=true"
import script from "./HealthRecords.vue?vue&type=script&lang=js"
export * from "./HealthRecords.vue?vue&type=script&lang=js"
import style0 from "./HealthRecords.vue?vue&type=style&index=0&id=5f595318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f595318",
  null
  
)

export default component.exports